<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";


export default {
  page: {
    title: "Nos Partenaires",
    meta: [{ name: "description", content: appConfig.description }]
  },
    components: { Layout},
    name: 'PartnerSection',

    data() {
        return {

      
    };
  },

  watch: {
    
  },
  mounted() {
    this.observeImages();
  },
  methods: {

    


    observeImages() {
      const images = document.querySelectorAll('.image-slide-in');

      const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate');
            observer.unobserve(entry.target);
          }
        });
      }, {
        threshold: 0.1,
      });

      images.forEach(image => {
        observer.observe(image);
      });
    }
  }
};
</script>
<template>
    <Layout>


    <div class="bg-white text-center pt-md-5 pb-md-5 pt-0 pb-0">
      <div>
        <div class="pt-0">
          <h1 class="pt-5 text-dark text-wrap font-weight-bold" style="font-size:2.5rem;">
            {{$t('ourPartner.ourPartners')}}
          </h1>
        </div>

        <hr class="separator-line mt-3">

        <div class="mt-5">
          <h6 class="header-60-width mx-auto text-dark font-size-16 text-wrap" style="letter-spacing: 0.08em; line-height: 1.8;">
            {{$t('ourPartner.partnersDescription')}} 
          </h6>
        </div>
      </div>
    </div>





        <div class="bg-white">

            <div class="text-center ">
                <div class="d-flex justify-content-center">
                    <iframe 
                        class="col-sm-12 col-md-8 mt-md-5 mt-2 m-md-0 m-4 responsive-iframe"
                        src="https://www.google.com/maps/d/embed?mid=1FI910OiNn__22aB2T6eRJFxnM8p0oA7f&amp;hl=en" 
                        style="border-radius: 8px; box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2); width: 100%; height: 700px;"
                        loading="lazy">
                    </iframe>
                </div>

            </div>




           


            <div class="header-60-width">

              <div class="text-center pt-md-5 pb-md-5 pt-0 pb-0">
      <div>
        <div class="pt-0">
          <h1 class="pt-5 text-dark text-wrap font-weight-bold" style="font-size:2.5rem;">
            {{$t('ourPartner.joinUs')}}
          </h1>
        </div>

        <hr class="separator-line mt-3 mb-3">

        <div class="mt-5">
          <h6 class="mx-auto text-dark font-size-16 text-wrap" style="letter-spacing: 0.08em; line-height: 1.8;">
            {{$t('ourPartner.partnersDescription')}} 
          </h6>
        </div>
      </div>
    </div>
            </div>



        </div>

      
    </Layout>
  </template>


  
  <style scoped>


  .header {
    background:  linear-gradient(19deg,rgba(55, 152, 91, 1) 0%,rgba(19, 116, 55, 1) , rgba(23, 83, 45, 1) 100%)!important;
    text-align: center;
  }
  
  .header-60-width,
.sub-title-60-width {
    max-width: 90%;
    margin: auto;
}

@media (min-width: 768px) {
    .header-60-width,
    .sub-title-60-width {
        max-width: 60%;
    }
}
  .separator-line {
    width: 15%;
    height: 4px;
    background-color: #1d3266 ;
    border: none;
    margin: auto; 
  }
  
  .sub-title-60-width {
    margin: 30px auto 0;
    color: #f7d584;
  }

  .responsive-iframe {
    height: 450px;
}

@media (min-width: 768px) {
    .responsive-iframe {
        height: 650px;
    }
}
  </style>
  


  <style scoped>
.image-slide-in {
  transform: translateX(-100%); 
  opacity: 0;
  transition: transform 1s ease-out, opacity 1s ease-out; 
}


.image-slide-in.animate {
  transform: translateX(0);
  opacity: 1;
}


  </style>